/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { type RouteObject } from 'react-router';

import { NotFoundPage } from 'sarsaparilla';

import { ErrorOrNotFoundPage } from 'shared-ui/components/ErrorPage/ErrorOrNotFoundPage';
import { ExternalAppLayout } from 'shared-ui/external-app-base';

import { HomePageContainer } from '../../src/containers/homepage/HomePageContainer';

import { externalRedirectRoutes } from './externalRedirectRoutes';
import { internalRedirectRoutes } from './internalRedirectRoutes';
import { accountActionsRoutes } from './accountActionsRoutes';
import { articleRoutes } from './articleRoutes';
import { infoPageRoutes } from './infoPageRoutes';

export const routes: RouteObject[] = [
    {
        path: '/',
        // Every page below owns its own `main` landmark — several deliberately
        // scope it to exclude a hero or a `role="complementary"` rail (see
        // ArticlePage), so the layout must not add one of its own.
        element: (
            <ExternalAppLayout
                globalLoadingUI="progressBar"
                wrapOutletInMain={false}
                isGuestAllowed={false}
            />
        ),
        // Fallback if the layout itself errors
        errorElement: <ErrorOrNotFoundPage wrapInMain />,
        children: [
            {
                // Pathless route: its errorElement renders inside the layout
                // Outlet, so errors appear with the top nav and footer
                errorElement: <ErrorOrNotFoundPage wrapInMain />,
                children: [
                    {
                        index: true,
                        element: <HomePageContainer />,
                    },
                    ...externalRedirectRoutes,
                    ...internalRedirectRoutes,
                    ...accountActionsRoutes,
                    ...articleRoutes,
                    ...infoPageRoutes,

                    // Catch-all
                    {
                        path: '*',
                        element: <NotFoundPage />,
                    },
                ],
            },
        ],
    },
];
